import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowDown = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="m12 15.713 6.01-6.01-1.413-1.415-4.597 4.6-4.596-4.6L5.99 9.702 12 15.713Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ArrowDown
